import {
  Core,
  SEND_OTP,
  SUBMIT_VISIT_REQUEST,
  VERIFY_OTP,
  VERIFY_REQUEST_STATUS,
} from '@services/Core';
import { AxiosPromise } from 'axios';

interface SendOTP {
  (data: { requestId: string; recaptchaToken: string }): AxiosPromise;
}
interface VerifyOtp {
  (data: { otp: string; requestId: string }): AxiosPromise;
}
interface VerifyRequestStatus {
  (data: { requestId: string }): AxiosPromise;
}
interface SubmitVisitRequest {
  (data: FormData): AxiosPromise<string>;
}

class VisitRequest extends Core {
  sendOTP: SendOTP = async ({ requestId, recaptchaToken }) => {
    return this.post(SEND_OTP(requestId), {}, { params: { recaptchaToken } });
  };

  verifyOTP: VerifyOtp = async (params) => {
    return this.post(VERIFY_OTP(), params, {
      headers: { 'Content-Type': 'application/json' },
    });
  };

  verifyRequestStatus: VerifyRequestStatus = async (params) => {
    return this.get(VERIFY_REQUEST_STATUS(params.requestId));
  };

  submitVisitRequest: SubmitVisitRequest = async (data) => {
    return this.post(SUBMIT_VISIT_REQUEST(), data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  };
}

export const visitRequest = new VisitRequest();
